var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"App"},[_c('TheHeader'),(_vm.loading)?_c('AppLoading'):(_vm.loaded)?[_c('TheMap'),_c('router-view')]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }